<template>
  <div class="full-width">
    <div class="table-container">
      <Table>
        <thead>
          <tr>
            <th>Invoice Date</th>
            <th>Line Item</th>
            <th>Opportunity Owner</th>
            <th>Invoice #</th>
            <th>Job #</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="historyRecord in serviceHistory" :key="historyRecord.id" :data-cy="`service-history-row-${historyRecord.invoice_line_item_id}`">
            <td>{{ shortDate(historyRecord.invoice_finalized_at) }}</td>
            <td>{{ historyRecord.invoice_line_item_unit_name || "--" }}</td>
            <td>{{ historyRecord.opportunity_owner_full_name || '--' }}</td>
            <td :class="{ voided: historyRecord.invoice_voided }">
              <a :href="historyRecord.links.invoice_url">
                {{ historyRecord.invoice_id }}
              </a>
            </td>
            <td>
              <a v-if="historyRecord.job_id" :href="historyRecord.links.job_url">{{ historyRecord.job_id }}</a>
              <span v-else>--</span>
            </td>
          </tr>
          <tr v-if="!serviceHistory.length">
            <td align="center" colspan="7">No service history available</td>
          </tr>
        </tbody>
      </Table>
    </div>
  </div>
</template>

<script>
import Table from '@/components/Table.vue';
import {shortDate} from "@/mixins";
export default {
  components: {
    Table,
  },
  props: {
    serviceHistory: {
      type: Array,
      default: () => []
    },
  },
  methods: {
    shortDate
  },
}
</script>

<style lang="scss" scoped>
.table-label {
  font-size: 1.3em;
  font-weight: bold;
}
.table-container {
  overflow-x: auto;
}
.voided {
  text-decoration: line-through;
}
</style>
